import { render, staticRenderFns } from "./DocumentsView.vue?vue&type=template&id=1048c7cd&scoped=true"
import script from "./DocumentsView.vue?vue&type=script&lang=js"
export * from "./DocumentsView.vue?vue&type=script&lang=js"
import style0 from "./DocumentsView.vue?vue&type=style&index=0&id=1048c7cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1048c7cd",
  null
  
)

export default component.exports